import { RLCard } from "../../../../../components";
import AIGeneratedIcon from "../../../../../components/icons/AIGeneratedIcon";
import SampleAttributionList from "../SampleAttributionList";
import { SampleIOCDataProps } from "../../../@types/ioc";

const SingleActorSampleAttribution = ({
  sampleIOCData
}: SampleIOCDataProps) => (
  <RLCard
    header={
      <RLCard.Header>
        <div className="flex flex-center flex-gap-2">
          <span>Sample Attribution</span>
          <AIGeneratedIcon />
        </div>
      </RLCard.Header>
    }
    content={
      <RLCard.Content>
        <SampleAttributionList sampleIOCData={sampleIOCData} />
      </RLCard.Content>
    }
  />
);

export default SingleActorSampleAttribution;
